import { Portal } from '@headlessui/react';
import { Buttons } from '@platform/shared/ui';
import React from 'react';

interface Props {
  title: string;
  assetName: string;
  onConfirm: () => void;
  onCloseRequest: () => void;
}

const DeleteConfirmationModal: React.FC<Props> = ({ title, assetName, onConfirm, onCloseRequest }) => {
  return (
    <Portal>
      <div
        data-te-modal-init
        className="fixed left-0 top-0 z-[1545455675] h-full w-full overflow-y-auto overflow-x-hidden bg-black/60 outline-none backdrop-opacity-60 backdrop-saturate-100"
        id={`{title}Center`}
        aria-modal="true"
        role="dialog"
      >
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                    <svg
                      className="h-6 w-6 text-red-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                      />
                    </svg>
                  </div>
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <h3 className="text-base font-semibold leading-6 text-gray-900" id="modal-title">
                      {title}
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        {`Are you sure you want to delete this ${assetName}? All data will be permanently removed. This action cannot be
                      undone.`}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="gap-4 bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <Buttons.Primary onClick={onConfirm} danger={true} size={'lg'}>
                  Delete
                </Buttons.Primary>
                <Buttons.Secondary onClick={onCloseRequest} danger={true} size={'lg'}>
                  Cancel
                </Buttons.Secondary>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default DeleteConfirmationModal;
